import { z } from 'zod'
import type { CardIconKey } from '@chillout/ui'

type Translate = (key: string, options?: Record<string, unknown>) => string

const AMOUNT_PER_STAMP_MIN = 50
const AMOUNT_PER_STAMP_MAX = 500

const cardIconKeySchema = z.custom<CardIconKey>((val) => typeof val === 'string' && val.length > 0)

export function loyaltyConfigSchema(t: Translate) {
  return z
    .object({
      earningMethod: z.enum(['spend_based', 'per_meal']),
      amountPerStamp: z.number({ error: t('loyalty.earningRule.amountRequiredError') }),
      stampTarget: z.number().int().positive(),
      completionRewardItemId: z.string().min(1, { message: t('loyalty.milestones.rewardItemRequiredError') }),
      completionCardIcon: cardIconKeySchema,
      milestones: z.array(
        z.object({
          stampPosition: z.number(),
          rewardItemId: z.string().min(1, { message: t('loyalty.milestones.rewardItemRequiredError') }),
          cardIcon: cardIconKeySchema,
        }),
      ),
    })
    // amountPerStamp only means something for spend_based — per_meal configs
    // carry it as 0 (mapped from a NULL amount_per_stamp column), which
    // would otherwise always fail the range check below and surface an
    // error under the disabled Spend Based card even when Per Meal is selected.
    .superRefine((data, ctx) => {
      if (data.earningMethod !== 'spend_based') return

      if (!Number.isInteger(data.amountPerStamp)) {
        ctx.addIssue({
          code: 'custom',
          path: ['amountPerStamp'],
          message: t('loyalty.earningRule.amountIntegerError'),
        })
        return
      }

      if (data.amountPerStamp < AMOUNT_PER_STAMP_MIN || data.amountPerStamp > AMOUNT_PER_STAMP_MAX) {
        ctx.addIssue({
          code: 'custom',
          path: ['amountPerStamp'],
          message: t('loyalty.earningRule.amountRangeError', { min: AMOUNT_PER_STAMP_MIN, max: AMOUNT_PER_STAMP_MAX }),
        })
      }
    })
}